import type { BannerItemStoryblok } from "@/component-types-sb";
import { isWithinStoryblokSchedule } from "./utils";

export const isBannerEligible = (
  banner: BannerItemStoryblok,
  campsiteId: string
) =>
  isWithinStoryblokSchedule(banner.publishDate, banner.expireDate) &&
  (!banner.campsites?.length ||
    banner.campsites.some((campsite) =>
      typeof campsite === "string"
        ? campsite === campsiteId
        : campsite.uuid === campsiteId
    ));
